import { render } from "./TabsPage.vue?vue&type=template&id=24acf714"
import script from "./TabsPage.vue?vue&type=script&lang=js"
export * from "./TabsPage.vue?vue&type=script&lang=js"

import "./TabsPage.vue?vue&type=style&index=0&id=24acf714&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\logistica\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__